import { updateFcmToken, getNotificationAuthToken } from 'src/api/notifications';
import { SET_NOTIFICATION_AUTH_TOKEN } from 'src/common/actions/constants';
import { isInAppNotificationAllowed } from 'src/utils/utils';
import config from 'src/globals';
import { getToken as getFcmToken } from 'firebase/messaging';
import { messaging } from 'src/firebase';
import { message } from 'antd';

const { FIREBASE_CONFIG = {}, FIREBASE_VAPID_KEY } = config;
const isFirebaseConfigEmpty = Object.keys(FIREBASE_CONFIG).length === 0;

const notificationAuthTokenInitialisation = async (dispatch) => {
  const response = await getNotificationAuthToken();
  dispatch({
    type: SET_NOTIFICATION_AUTH_TOKEN,
    data: response?.data?.authToken,
  });
};

export const notificationInitialisation = (dispatch) => {
  if (isInAppNotificationAllowed()) {
    notificationAuthTokenInitialisation(dispatch);
  }
  if (!FIREBASE_VAPID_KEY || isFirebaseConfigEmpty) {
    return;
  }
  const { userAgent } = navigator;
  const requestPermission = async (removeEventListener = true) => {
    if (!('Notification' in window)) {
      return;
    }
    try {
      const result = await Notification?.requestPermission();
      if (result === 'granted' && !userAgent.includes('iPhone')) {
        let serviceWorkerRegistration;
        let scriptURL = '/crm-assets/firebase-messaging-sw.js';
        scriptURL += `?firebaseConfig=${JSON.stringify(FIREBASE_CONFIG)}`;

        if ('serviceWorker' in navigator) {
          serviceWorkerRegistration = await navigator.serviceWorker.register(scriptURL);
        }
        const token = await getFcmToken(messaging, {
          vapidKey: FIREBASE_VAPID_KEY,
          serviceWorkerRegistration,
        });
        await updateFcmToken({ fcm_token: token });
      }
      if (removeEventListener) {
        document.removeEventListener('click', requestPermission);
      }
    } catch (error) {
      message.error('Error requesting permission');
    }
  };
  if (userAgent.includes('Chrome')) {
    requestPermission(false);
  } else {
    document.addEventListener('click', requestPermission);
  }
};
